// Returns array of parsed HTML elements, with each element as string containing start tag element.
const _parseHtmlElements = (html) => {
  const matches = html && html.match(/<\w+.*?>/g);
  return matches ? matches : [];
};

const _parseTagFromHtmlElement = (element) => {
  const regex = /<(\w+)/g;
  const matchResults = regex.exec(element);
  return matchResults ? matchResults[1].toLowerCase() : null;
};

const _parseClassFromHtmlElement = (element) => {
  const regex = /class\s*=\s*"([a-zA-Z0-9_-]*?)"/g;
  const matchResults = regex.exec(element);
  return matchResults ? matchResults[1] : null;
};

// This is a very conservative check for characters that are necessary for creating HTML elements (and hence security
// vulnerabilities). Not everything it complains about is a vulnerability, but it errs on the side of safety and
// simplicity. That's why it's named "mightContainHtmlTag" instead of "containsHtmlTag".
export const mightContainHtmlTag = (value) => value && (value.indexOf('<') !== -1 || value.indexOf('>') !== -1);

/** Check for elements matching selectors in HTML. Intended to be used for basic unit test checks,
 * and if we start writing a lot of code here, it will probably be better to go to a 3rd party library.
 * @param html HTML source to check.
 * @param selector Can be in form of 'element' or 'element.class'.
 * @return Count of matches found, 0 if none.
 */
export const doesHtmlContain = (html, selector) => {
  let foundCount = 0;
  const periodPos = selector.indexOf('.');
  const tag = ((periodPos === -1) ? selector : selector.substr(0, periodPos)).toLowerCase();
  const className = (periodPos === -1) ? null : selector.substr(periodPos + 1);
  const elements = _parseHtmlElements(html);
  elements.forEach((element) => {
    const parsedTag = _parseTagFromHtmlElement(element);
    if (parsedTag === tag) {
      if (className) {
        const parsedClass = _parseClassFromHtmlElement(element);
        if (parsedClass === className) {
          ++foundCount;
        }
      } else {
        ++foundCount;
      }
    }
  });
  return foundCount;
};

export const unitTestPrivate = {
  _parseHtmlElements,
  _parseTagFromHtmlElement,
  _parseClassFromHtmlElement
};

/** Prefix the value of any "id" attribute of an HTML element with specified text.
 * @param html Source HTML in which to make replacements.
 * @param prefix Prefix to add in front of "id" attribute values.
 * @return Modified HTML
 */
export const addPrefixToElementIds = (html, prefix) => {
  // The regex matches ID attribute values, e.g. `dog` in <a id="dog">. There are capture groups
  // for the ID value ("dog") and also the text preceding and following the ID value. All 3 capture groups are
  // combined together for "replace all" functionality.
  const regex = /(<\w+.*?id\s*=\s*['"])(\w*)(['"].*?>)/g;
  const newHtml = html.replace(regex, (entireMatch, preceding, idValue, following) => {
    return preceding + prefix + idValue + following;
  });
  return newHtml;
};
